import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import { useDataListContext } from '../../../data-list/use-data-list.ts'

export const CardDetailsCompactItem = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <div className={cn('flex gap-x-1 items-center', className)}>{children}</div>
  )
}

export const CardDetailsCompactItemTitle = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  const { fontSizeClassName, titleColorClassName } = useDataListContext()
  return (
    <div className={cn(fontSizeClassName, titleColorClassName, className)}>
      {children}
    </div>
  )
}

export const CardDetailsCompactItemDescription = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  const { descriptionColorClassName, fontSizeClassName } = useDataListContext()

  return (
    <div
      className={cn(descriptionColorClassName, fontSizeClassName, className)}
    >
      {children}
    </div>
  )
}
